<template>
    <icon-base v-bind="$props">
        <circle cx="7" cy="17" r="2.5" />
        <circle cx="17" cy="7" r="2.5" />
        <circle cx="17" cy="17" r="2.5" />
        <path d="M9 16l6 -8" />
        <path d="M14.5 8.5l2 7" />
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
